// @flow
import {
  GET_AI_SYNONYM_FEATURE_FAILURE,
  GET_AI_SYNONYM_FEATURE_REQUEST,
  GET_AI_SYNONYM_FEATURE_SUCCESS,
  GET_SEARCH_FEATURES_FAILURE,
  GET_SEARCH_FEATURES_REQUEST,
  GET_SEARCH_FEATURES_SUCCESS,
  SearchControlAction,
  SearchControlState
} from 'stores/flow-type/search-control.type';

const initialState: SearchControlAction = {
  inCollectionSearch: 'off',
  performanceRanking: 'off',
  personalization: 'off',
  searchResultPage: 'on',
  redirect: 'off',
  semantic: 'off',
  suggestionDictionary: 'off',
  stopWords: 'off',
  synonym: 'off',
  searchable: 'off',
  merchandising: 'off',
  aiSynonym: 'off',
  featureGetting: false,
  aiSynonymGetting: false
};
const searchControlReducers = (state: SearchControlState = initialState, action: SearchControlAction) => {
  switch (action.type) {
    case GET_SEARCH_FEATURES_REQUEST:
      return { ...state, featureGetting: true, success: false };
    case GET_SEARCH_FEATURES_SUCCESS: {
      return {
        ...state,
        ...action.payload.data,
        featureGetting: false,
        success: true
      };
    }
    case GET_SEARCH_FEATURES_FAILURE:
      return {
        ...state,
        featureGetting: false,
        success: false
      };
    case GET_AI_SYNONYM_FEATURE_REQUEST:
      return { ...state, aiSynonymGetting: true, success: false };
    case GET_AI_SYNONYM_FEATURE_SUCCESS: {
      return {
        ...state,
        aiSynonym: action.payload.status,
        aiSynonymGetting: false,
        success: true
      };
    }
    case GET_AI_SYNONYM_FEATURE_FAILURE:
      return {
        ...state,
        aiSynonymGetting: false,
        success: false
      };
    default:
      return state;
  }
};
export default searchControlReducers;